// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-container {
  width: 100%;
  column-gap: 16px;
  row-gap: 16px;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 767.88px) {
  .grid-container {
    grid-template-columns: repeat(4, 1fr);
    column-gap: 8px;
  }
  .grid-container .sm,
  .grid-container .sm-1 {
    grid-column: span 1;
  }
  .grid-container .sm-2 {
    grid-column: span 2;
  }
  .grid-container .sm-3 {
    grid-column: span 3;
  }
  .grid-container .sm-4 {
    grid-column: span 4;
  }
}
/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 1024px) {
  .grid-container {
    grid-template-columns: repeat(8, 1fr);
    column-gap: 16px;
  }
  .grid-container .md,
  .grid-container .md-1 {
    grid-column: span 1;
  }
  .grid-container .md-2 {
    grid-column: span 2;
  }
  .grid-container .md-3 {
    grid-column: span 3;
  }
  .grid-container .md-4 {
    grid-column: span 4;
  }
  .grid-container .md-5 {
    grid-column: span 5;
  }
  .grid-container .md-6 {
    grid-column: span 6;
  }
  .grid-container .md-7 {
    grid-column: span 7;
  }
  .grid-container .md-8 {
    grid-column: span 8;
  }
}
@media (min-width: 1024px) {
  .xl,
  .xl-1 {
    grid-column: span 1;
  }
  .xl-2 {
    grid-column: span 2;
  }
  .xl-3 {
    grid-column: span 3;
  }
  .xl-4 {
    grid-column: span 4;
  }
  .xl-5 {
    grid-column: span 5;
  }
  .xl-6 {
    grid-column: span 6;
  }
  .xl-7 {
    grid-column: span 7;
  }
  .xl-8 {
    grid-column: span 8;
  }
  .xl-9 {
    grid-column: span 9;
  }
  .xl-10 {
    grid-column: span 10;
  }
  .xl-11 {
    grid-column: span 11;
  }
  .xl-12 {
    grid-column: span 12;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/grid-system.scss"],"names":[],"mappings":"AAAA;EAGI,WAAA;EAEK,gBAAA;EACL,aAAA;AADJ;;AAIA,mDAAA;AACA;EACI;IACI,qCAAA;IAEK,eAAA;EADX;EAGM;;IAEI,mBAAA;EADV;EAGM;IACI,mBAAA;EADV;EAGM;IACI,mBAAA;EADV;EAGM;IACI,mBAAA;EADV;AACF;AAKA,2CAAA;AACA;EACI;IACI,qCAAA;IAEK,gBAAA;EAHX;EAKM;;IAEI,mBAAA;EAHV;EAKM;IACI,mBAAA;EAHV;EAKM;IACI,mBAAA;EAHV;EAKM;IACI,mBAAA;EAHV;EAKM;IACI,mBAAA;EAHV;EAKM;IACI,mBAAA;EAHV;EAKM;IACI,mBAAA;EAHV;EAKM;IACI,mBAAA;EAHV;AACF;AAQA;EACI;;IAEI,mBAAA;EANN;EAQE;IACI,mBAAA;EANN;EAQE;IACI,mBAAA;EANN;EAQE;IACI,mBAAA;EANN;EAQE;IACI,mBAAA;EANN;EAQE;IACI,mBAAA;EANN;EAQE;IACI,mBAAA;EANN;EAQE;IACI,mBAAA;EANN;EAQE;IACI,mBAAA;EANN;EAQE;IACI,oBAAA;EANN;EAQE;IACI,oBAAA;EANN;EAQE;IACI,oBAAA;EANN;AACF","sourcesContent":[".grid-container {\n    // display: grid;\n    // grid-template-columns: repeat(12, 1fr);\n    width: 100%;\n    -moz-column-gap: 16px;\n         column-gap: 16px;\n    row-gap: 16px;\n}\n\n/* Small devices (landscape phones, 576px and up) */\n@media (max-width: 767.88px) {\n    .grid-container {\n        grid-template-columns: repeat(4, 1fr);\n        -moz-column-gap: 8px;\n             column-gap: 8px;\n\n        .sm,\n        .sm-1 {\n            grid-column: span 1;\n        }\n        .sm-2 {\n            grid-column: span 2;\n        }\n        .sm-3 {\n            grid-column: span 3;\n        }\n        .sm-4 {\n            grid-column: span 4;\n        }\n    }\n}\n\n/* Medium devices (tablets, 768px and up) */\n@media (min-width: 768px) and (max-width: 1024px) {\n    .grid-container {\n        grid-template-columns: repeat(8, 1fr);\n        -moz-column-gap: 16px;\n             column-gap: 16px;\n\n        .md,\n        .md-1 {\n            grid-column: span 1;\n        }\n        .md-2 {\n            grid-column: span 2;\n        }\n        .md-3 {\n            grid-column: span 3;\n        }\n        .md-4 {\n            grid-column: span 4;\n        }\n        .md-5 {\n            grid-column: span 5;\n        }\n        .md-6 {\n            grid-column: span 6;\n        }\n        .md-7 {\n            grid-column: span 7;\n        }\n        .md-8 {\n            grid-column: span 8;\n        }\n    }\n}\n\n\n@media (min-width: 1024px){\n    .xl,\n    .xl-1 {\n        grid-column: span 1;\n    }\n    .xl-2 {\n        grid-column: span 2;\n    }\n    .xl-3 {\n        grid-column: span 3;\n    }\n    .xl-4 {\n        grid-column: span 4;\n    }\n    .xl-5 {\n        grid-column: span 5;\n    }\n    .xl-6 {\n        grid-column: span 6;\n    }\n    .xl-7 {\n        grid-column: span 7;\n    }\n    .xl-8 {\n        grid-column: span 8;\n    }\n    .xl-9 {\n        grid-column: span 9;\n    }\n    .xl-10 {\n        grid-column: span 10;\n    }\n    .xl-11 {\n        grid-column: span 11;\n    }\n    .xl-12 {\n        grid-column: span 12;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
